<div class="container my-4">
    <div class="row">
        <div class="col-12">
            <span class="title_header_bar">Home Connect Messaging</span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="hcmessageForm">
            <div class="row mt-3">
                <div class="col-xl-12">
                    <div class="row d-flex justify-content-between">
                        <div class="col-xl-5 d-flex" style="height: fit-content;align-self: end;">
                            <!-- <button class="btn btn-secondary mr-3 " (click)="Reset()">
                                <i class="fa fa-refresh"></i> Refresh
                            </button> -->
                            <app-button (refreshClicked)="Reset()"></app-button>

                            <button class="excel_btn mr-3" style="white-space:nowrap;" (click)="exportData()">
                                <i class="fa fa-file-excel"></i> Export
                            </button>
                            <button class="btn btn-primary mr-3" style="white-space:nowrap;"
                                [routerLink]="'/messaging-add'">
                                <i class="fa fa-plus"></i> Add
                            </button>


                        </div>
                        <div class="col-2">
                            <button type="button" class="btn btn-primary ml-2 d-flex"
                                (click)="filterOpen = !filterOpen">
                                <ng-container *ngIf="!filterOpen">
                                    <app-icon name="arrow-rounded-down-12x7" size="12x7"></app-icon>
                                </ng-container>
                                <ng-container *ngIf="filterOpen">
                                    <app-icon name="arrow-rounded-up-13x8" size="13x8"></app-icon>
                                </ng-container>
                                <span class="ml-2">Filters</span>
                            </button>
                        </div>
                    </div>
                    <div [@detailExpand]="filterOpen ? 'expanded' : 'collapsed'" style="overflow: hidden;">
                        <hr>
                        <div class="subtitle_header">Filterd By</div>
                        <div class="row">
                            <div class="col-xl-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Messaging Type</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="messagingType"
                                        placeholder="Please Select Messaging Type">
                                        <mat-select-filter [displayMember]="'value'" [array]="individualOrGroupList"
                                            (filteredReturn)="filteredList1 = $event"></mat-select-filter>
                                        <mat-option *ngFor="let item of filteredList1" [value]="item.key"
                                            style="overflow-y: scroll !important;">
                                            {{item.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-xl-6 mt-4">
                                <mat-form-field appearance="fill" hideRequiredMarker>
                                    <mat-label>Notification Type</mat-label>
                                    <mat-select class="scrollbarcs" formControlName="messageNotificationType"
                                        placeholder="Please Select Notification Type">
                                        <mat-select-filter [displayMember]="'value'" [array]="notificationTypeList"
                                            (filteredReturn)="filteredList2 = $event"></mat-select-filter>
                                        <mat-option *ngFor="let item of filteredList2" [value]="item.key"
                                            style="overflow-y: scroll !important;">
                                            {{item.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-xl-6 mt-4">
                                <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                    <mat-label>Start Date</mat-label>
                                    <input readonly matInput [matDatepicker]="startDate" formControlName="startDate"
                                        selectable="isSelectable(date,type)" id="startDate" autocomplete="off"
                                        placeholder="Select From Date" class="custom-input-border" specialIsAlphaNumeric
                                        (click)="openStartDateDatePicker()">
                                    <mat-datepicker-toggle matSuffix [for]="startDate" style="color:black;">
                                        <button mat-icon-button>
                                            <mat-icon>event</mat-icon>
                                        </button>
                                    </mat-datepicker-toggle>
                                    <mat-datepicker #startDate></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-xl-6 mt-4">
                                <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                    <mat-label>End Date</mat-label>
                                    <input readonly matInput [matDatepicker]="endDate" formControlName="endDate"
                                        selectable="isSelectable(date,type)" id="endDate" autocomplete="off"
                                        [min]="toMinDate" [max]="toMaxDate" placeholder="Select To Date"
                                        class="custom-input-border" specialIsAlphaNumeric
                                        (click)="openEndDateDatePicker()">
                                    <mat-datepicker-toggle matSuffix [for]="endDate" style="color:black;">
                                        <button mat-icon-button>
                                            <mat-icon>event</mat-icon>
                                        </button>
                                    </mat-datepicker-toggle>
                                    <mat-datepicker #endDate></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-xl-6"></div>
                            <div class="col-12 mt-4 d-flex justify-content-end">
                                <button class="btn btn-secondary mr-3" (click)="filterSearchClick()">
                                  <i class="fa fa-search"></i>  Search
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-2"></div>
        </form>
        <div class="table-responsive mt-2 mt-4">
            <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">
                <ng-container matColumnDef="MessagingType">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="MessagingType">Messaging Type
                    </mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">
                            {{dataField.messagingTypeString}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="NotificationType">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="NotificationType">Notification Type
                    </mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">
                            {{dataField.notificationTypeString}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Recipient">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="Recipient">Recipient</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">
                            {{dataField.messagingRecipientString}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Status">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="Status">Status</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">
                            {{dataField.messageStatusTypeString }}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Action">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="Action">Action</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <div class="text-truncate text-center">
                            <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-eye mr-3"
                                (click)="viewMail(dataField)"></i>
                        </div>
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                </mat-row>
            </mat-table>
            <div *ngIf="dataSource.data.length == 0" class="no-data-message">
                <p>No data found</p>
            </div>
        </div>

        <div class="table_pagenation">
            <mat-paginator #paginator [length]="dataSource!==null && dataSource.filteredData.length" [pageIndex]="0"
                [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
            </mat-paginator>
        </div>
    </div>
</div>